<filters-bar
[filters]="filters"
[language]="language"
[selectedFilters]="selectedFilters"
[resultsCount]="resultsCount"
(onRemove)="removeFilter($event)"
(onSubmitBloque)="addBloqueFilter($event)"
(onRemoveAll)="removeAllFilters()"
(onSelect)="selectFilter($event)">
</filters-bar>
